import React from "react";
import { motion } from "framer-motion";

const ContactSupport = () => {
  return (
    <section className="py-16 px-4 bg-white" id="contact-support">
      <div className="max-w-5xl mx-auto">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Contact & Support
          </h2>
          <p className="text-gray-600 mt-2">
            Have questions or need assistance? We're here to help you succeed.
          </p>
        </motion.div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-md"
          >
            <h3 className="text-lg font-semibold mb-4">Send Us a Message</h3>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Full Name"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option>Select a subject</option>
                <option>General Inquiry</option>
                <option>Technical Support</option>
                <option>Business Partnership</option>
              </select>
              <textarea
                rows="5"
                placeholder="Your message"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
              <button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-lg transition duration-300"
              >
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Contact Info & Map */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            {/* Contact Info Box */}
            <div className="bg-white p-6 rounded-xl shadow-md space-y-4">
              <h3 className="text-lg font-semibold mb-2">Contact Information</h3>
              <div className="space-y-2 text-sm">
                <div>
                  <strong>Email Us</strong>
                  <p className="text-gray-600">
                    support@startuplatform.com <br />
                    partnerships@startuplatform.com
                  </p>
                </div>
                <div>
                  <strong>Call Us</strong>
                  <p className="text-gray-600">
                    +1 (555) 123-4567 <br />
                    Mon-Fri, 9am-6pm EST
                  </p>
                </div>
                <div>
                  <strong>Visit Us</strong>
                  <p className="text-gray-600">
                    123 Innovation Way <br />
                    San Francisco, CA 94107
                  </p>
                </div>
              </div>
            </div>

            {/* Embedded Map */}
            <div className="rounded-xl overflow-hidden shadow-md">
              <iframe
                title="Google Map"
                className="w-full h-48 md:h-64"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0866941555174!2d-122.40101358468138!3d37.782111179756404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064c507d7f7%3A0x6a6979aadd2a42d6!2s123%20Innovation%20Way%2C%20San%20Francisco%2C%20CA%2094107%2C%20USA!5e0!3m2!1sen!2sin!4v1622715907699!5m2!1sen!2sin"
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSupport;
